import { FC } from 'react'
import { PersonalPayButtonProps } from '../types/types'
import { Oval } from 'react-loader-spinner'
import '../styles/personalPayButton.css'

const PersonalPayButton: FC<PersonalPayButtonProps> = ({ handleClickPersonalPayBtn, errGenerateOrder, isLoading }) => {
    return (
        <button
            id='personal-pay-sdk-btn'
            className='personalPayBtn'
            onClick={handleClickPersonalPayBtn}
            disabled={isLoading}
        >
            {
                isLoading ?
                    <Oval
                        color='rgb(255, 255, 255)'
                        secondaryColor='rgb(255, 255, 255)'
                        height={20}
                        width={20}
                    /> : 'Pagar con Personal Pay'
            }
        </button>
    )
}

export default PersonalPayButton